<template>
  <div
    class="jade-alert"
    :class="computedClass"
    v-bind="$attrs"
    role="alert"
  >
    <div
      class="jade-alert__main"
      :class="computedClassMain"
    >
      <jade-icon
        v-if="showIcon"
        size="medium"
        :use="computedIcons"
      />

      <div class="jade-alert__content">
        <jade-text
          v-if="title"
          variant="text-medium"
          weight="semibold"
          color="current-color"
          data-testid="text-title"
        >
          {{ title }}
        </jade-text>

        <jade-text
          v-if="$slots.default"
          variant="text-medium"
          weight="regular"
          color="current-color"
          data-testid="text-default"
        >
          <slot></slot>
        </jade-text>

        <jade-link
          v-if="link"
          :href="$sanitize(link.href)"
          :rel="link?.rel"
          :target="link?.target"
          :variant="variant"
          data-testid="jade-link"
          @click="handleLinkClick"
        >
          {{ link.text }}
        </jade-link>
      </div>
    </div>
    <div
      v-if="onDismiss"
      class="jade-alert__dismiss"
    >
      <jade-icon-button
        icon="close"
        variant="neutral-ghost"
        size="medium"
        @click="$emit('onDismiss')"
      />
    </div>
  </div>
</template>

<script>
import JadeText from '../JadeText/index.vue'
import JadeIcon from '../JadeIcon/index.vue'
import JadeIconButton from '../JadeIconButton/index.vue'
import JadeLink from '../JadeLink/index.vue'
import COLOR_ENUM from '../enums/colors.enum'

const VARIANT_X_ICON = {
  [COLOR_ENUM.INFO]: 'circle-info',
  [COLOR_ENUM.WARNING]: 'warning',
  [COLOR_ENUM.NEGATIVE]: 'circle-error',
  [COLOR_ENUM.POSITIVE]: 'circle-check',
  [COLOR_ENUM.NEUTRAL]: 'circle-info'
}

export default {
  name: 'JadeAlert',

  components: {
    JadeText,
    JadeIcon,
    JadeIconButton,
    JadeLink
  },

  props: {
    showIcon: Boolean,
    onDismiss: Boolean,
    title: String,
    icon: String,
    link: Object,
    variant: {
      type: String,
      validation: voice => Object.keys(VARIANT_X_ICON).includes(voice),
      default: COLOR_ENUM.NEUTRAL
    }
  },

  computed: {
    computedClass () {
      return {
        [`is-${this.variant}`]: this.variant
      }
    },
    computedClassMain () {
      return {
        'is-dismissible': this.onDismiss
      }
    },
    computedIcons () {
      return this.icon ?? VARIANT_X_ICON[this.variant] ?? VARIANT_X_ICON.neutral
    }
  },
  methods: {
    handleLinkClick () {
      this.$emit('handleLinkClick')
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/alert.css';
</style>
